import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { X } from "lucide-react";

const ViewWorkersDialog = ({ open, onClose, workers = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Workers List
        </Typography>
        <IconButton onClick={onClose} size="small">
          <X size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2, py: 1 }}>
        {workers.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 4,
              color: "text.secondary",
            }}
          >
            <Typography>No workers found</Typography>
          </Box>
        ) : (
          <List sx={{ pt: 0 }}>
            {workers.map((worker, index) => (
              <ListItem
                key={worker._id || index}
                sx={{
                  px: 0,
                  py: 1.5,
                  borderBottom: index < workers.length - 1 ? "1px solid #f0f0f0" : "none",
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    src={worker.profileImage}
                    alt={`${worker.firstName} ${worker.lastName}`}
                    sx={{ width: 48, height: 48 }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle1" fontWeight={500}>
                      {worker.firstName} {worker.lastName}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="text.secondary">
                      {worker.email}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Total: {workers.length} workers
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default ViewWorkersDialog;
